import { useDataSource } from '@/features/data/DataSourceContext';
import { useGetSettingsQuery } from './api/settings.api';

export function useProfilePhotoUrl(): string | undefined {
  const { source } = useDataSource();
  return useGetSettingsQuery({ source, params: undefined }, { skip: source === 'live' }).data
    ?.account.photoUrl;
}
